module.exports = __webpack_public_path__ + "img/SketchPngda42bf625197ddbb0318b92615e29113bcab76c20772e08a14070f1133f90ea1.3a3691b8.png";